import { patchState, signalStore, withHooks, withMethods } from '@ngrx/signals';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { PleaService } from './plea.service';
import { tapResponse } from '@ngrx/operators';
import { AuthStore, type OffensePlea } from '../../../../core';
import { pipe, switchMap, tap } from 'rxjs';
import { setError, setLoaded, setLoading, withCallState, withReset } from '@ngrx-toolkit/core';

export const PleaStore = signalStore(
  { providedIn: 'root' },
  withCallState(),
  withReset(),
  withMethods((store, api = inject(PleaService)) => ({
    submit: rxMethod<{ pleas: Array<OffensePlea>; isPleaForm?: boolean; onSuccess(): void }>(
      pipe(
        tap(() => patchState(store, setLoading())),
        switchMap(({ pleas, isPleaForm, onSuccess }) =>
          api.submit(pleas, isPleaForm).pipe(
            tapResponse({
              next: () => {
                patchState(store, setLoaded());
                onSuccess();
              },
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks({
    onInit(store, authStore = inject(AuthStore)) {
      authStore.logout$.subscribe(() => store.resetState());
    },
  }),
);
